import moment from "moment";
import React, { FunctionComponent } from "react";

export const Greeting: FunctionComponent = () => {
	const currentTime = moment(new Date());
	let greetingText = "Hello";

	const splitAfternoon = 12; // 24hr time to split the afternoon
	const splitEvening = 17; // 24hr time to split the evening
	const currentHour = parseFloat(currentTime.format("HH"));

	if (currentHour >= splitAfternoon && currentHour <= splitEvening) {
		// Between 12 PM and 5PM
		greetingText = "Good afternoon";
	} else if (currentHour >= splitEvening) {
		// Between 5PM and Midnight
		greetingText = "Good evening";
	} else {
		// Between dawn and noon
		greetingText = "Good morning";
	}

	return <span className="greeting-text">{greetingText}</span>;
};
